import styled from "@emotion/styled";

const VinNumber = styled("span")`
    color: ${(props) => props.theme.palette.grey[20]};
    font-size: 13px;
    text-transform: uppercase;
`;

export default VinNumber;
